import { connect } from 'react-redux';
import SendLetter from '../components/SendLetter/SendLetter';
import { getExecutiveListById } from '../redux/actions/ExecutiveList';
import * as actions from '../redux/actions/SendLetter';
import { getUser, getSenders, postSender, getOrderContacts, postOrderContacts } from '../redux/actions/AccountSetting';
import { getAddressById } from '../redux/actions/AddressDetail';
import { getSalesforceConfig } from "../redux/actions/Salesforce";
import { getLetterOrderList, getLetterOrdersLetterContentCheck } from '../redux/actions/LetterOrderList';
import { LetterOrdersApi } from '../redux/api/LetterOrdersApi';
import { goBack, push } from 'react-router-redux';

const mapStateToProps = (state) => ({
  executiveListItem: state.executiveDetail.item,
  addressItem: state.addressDetail.contact,
  isLoadingItem: state.executiveDetail.isLoading,
  isPosting: state.sendLetter.isPosting,
  errorMessage: state.sendLetter.errorMessage,
  shortMessage: state.sendLetter.shortMessage,
  successMessage: state.sendLetter.successMessage,
  user: state.accountSetting.user,
  routerInfo: state.router.location,
  senders: state.accountSetting.senders.toIndexedSeq().toArray(),
  orderContacts: state.accountSetting.orderContacts.toIndexedSeq().toArray(),
  isLoadingOrderContacts: state.accountSetting.isLoadingOrderContacts,
  isLoadingSenders: state.accountSetting.isLoadingSenders,
  isSavingSender: state.sendLetter.isSaving,
  isSavingOrderContact: state.sendLetter.isSavingOrderContact,
  orderContact: state.sendLetter.orderContact,
  error: state.accountSetting.error,
  sender: state.sendLetter.sender,
  showSendLetterInfoBox: state.sendLetter.showSendLetterInfoBox,
  address_import_mappings_flag: state.salesforce.address_import_mappings_flag,
  exe_export_mappings_flag: state.salesforce.exe_export_mappings_flag,
  letterOrderList: state.letterOrderList.letterOrderList,
  isLoadingLetterOrderList: state.letterOrderList.isLoading,
  isCheckOK: state.letterOrderList.isCheckOK,
  checkMessage: state.letterOrderList.checkMessage,
})

const mapDispatchToProps = dispatch => ({
  getExecutiveListById(id, data) {
    dispatch(getExecutiveListById(id, data))
  },

  getAddressById(id) {
    dispatch(getAddressById(id));
  },

  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  postLetterOrdersOrder(params) {
    dispatch(actions.postLetterOrdersOrder(params));
  },

  getUserInfo() {
    dispatch(getUser());
  },

  getSenders() {
    dispatch(getSenders());
  },

  postSender(data) {
    dispatch(postSender(data));
  },

  getOrderContacts() {
    dispatch(getOrderContacts());
  },

  postOrderContacts(data) {
    dispatch(postOrderContacts(data));
  },

  getSalesforceConfig() {
    dispatch(getSalesforceConfig());
  },

  setShowSendLetterInfoBox(value) {
    dispatch(actions.setShowSendLetterInfoBox(value));
  },

  getLetterOrderList(data, overwrite) {
    dispatch(getLetterOrderList(data, overwrite));
  },

  getLetterOrdersLetterContentCheck(data) {
    dispatch(getLetterOrdersLetterContentCheck(data));
  },

  validateAdditionalFile(formData) {
    return LetterOrdersApi.postLetterOrdersAdditionalFileValidate(formData, dispatch);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SendLetter);



// WEBPACK FOOTER //
// ./src/containers/SendLetter.js